export default "__VITE_ASSET__CbDbnyhN__"